module.exports = __webpack_public_path__ + "static/media/toool-dark-logo.e4254a6d.svg";